import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
import React from 'react';
/**
 * 默认 a 标签
 * https://stackoverflow.com/questions/10510191/valid-to-use-a-anchor-tag-without-href-attribute
 */

export default function Link(props) {
  var handleClick = function handleClick(e) {
    e.preventDefault();
  };

  return /*#__PURE__*/React.createElement("a", _Object$assign({
    onClick: handleClick
  }, props));
}